<s1-input-label [label]="label">
  @if (!readonly) {
    <input class="form-control" [ngClass]="{'is-invalid' : !checkIsValid() }" type="text" bsDatepicker [bsConfig]="bsConfig" [formControl]="control" [placeholder]="placeholder" [readonly]="readonly" />
  }
  @if (readonly) {
    <input class="form-control" [ngClass]="{'is-invalid' : !checkIsValid() }" type="text" [value]="readableDate()" [readonly]="true" />
  }
</s1-input-label>